
import { Clock, TrendingUp, DollarSign, AlertTriangle } from 'lucide-react';

const benefits = [
  {
    icon: <Clock className="w-6 h-6 text-white" />,
    iconBg: "bg-gradient-to-br from-wamy-500 to-wamy-600",
    title: "Faster Claim Processing",
    description: "Automates document intake and underwriting, reducing manual work and accelerating case preparation."
  },
  {
    icon: <DollarSign className="w-6 h-6 text-white" />,
    iconBg: "bg-gradient-to-br from-wamy-600 to-teal-500",
    title: "Lower Litigation Expenses",
    description: "Streamlines workflows and minimizes time spent gathering evidence, cutting down on administrative and legal costs."
  },
  {
    icon: <TrendingUp className="w-6 h-6 text-white" />,
    iconBg: "bg-gradient-to-br from-teal-500 to-teal-600",
    title: "Higher Claim Approval Rates",
    description: "Strengthens cases with enriched claim data, AI-driven insights, and historical records, improving settlement success."
  },
  {
    icon: <AlertTriangle className="w-6 h-6 text-white" />,
    iconBg: "bg-gradient-to-br from-wamy-500 to-wamy-600",
    title: "Early Risk Detection",
    description: "Flags weak or problematic claims before litigation begins, allowing attorneys to focus on high-value cases."
  }
];

const Benefits = () => {
  return (
    <section id="benefits" className="py-16 md:py-24 relative">
      {/* Background elements */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-wamy-100 rounded-full filter blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-teal-100 rounded-full filter blur-3xl opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Benefits of Using <span className="text-gradient">Wamy</span>
          </h2>
          <p className="text-lg text-gray-600">
            Wamy streamlines claim processing, reduces costs, enhances decision-making, and improves outcomes with AI-powered automation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1 opacity-0 flex flex-col"
              style={{ 
                animation: `fade-in 0.5s ease-out ${0.1 * index}s forwards`
              }}
            >
              <div className="p-6 flex-1">
                <div className="flex items-center mb-4">
                  <div className={`w-12 h-12 rounded-lg ${benefit.iconBg} flex items-center justify-center mr-4 shadow-md`}>
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-semibold">{benefit.title}</h3>
                </div>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
              <div className="h-1 bg-gradient-to-r from-wamy-500 via-wamy-600 to-teal-500 mt-auto"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
